// extracted by mini-css-extract-plugin
export var navbar = "NavBar-module--navbar--w4Abo";
export var navbarList = "NavBar-module--navbarList--suVXl";